
'use strict';


/**
 * @type Controller
 * @name InformationDialogCtrl
 * @packageName treecontroller_dialog_ctrl.js
 *
 * @description
 *
 * The `TreeControllerDialogCtrl` interaction delete mdDialog for treecontrol
 *
 */
class TreeControllerDialogCtrl
{

    constructor( $scope, $mdDialog, $http, genreModel ) {

   		//Attach dependicies to class root
        this.$scope = $scope;
    	this.$mdDialog = $mdDialog;
    	this.$http = $http;
        this.genreModel = genreModel;

    	//Tree Options
    	$scope.treeOptions = {

            nodeChildren: 'children',
            dirSelectable: true,
            allowDeselect: false
        };

        //Load Tree Data
        this.loadTreeData ();

    	//Clicked CANCEL button!
    	$scope.cancel = () => {

    		this.cancelButton();
    	};

        //Clicked on a tree option
        $scope.selectGenre = ( $node ) => {

            this.selectGenre( $node );
        };

        //Return selected option
        $scope.selected = () => {

            return this.genreModel;
        };
	}


	/*
     * Load tree data in view
     */	
    loadTreeData () {

    	//Need to be refactord to ngResource
    	this.$http.get('/genres/tree').then(result => {

            this.$scope.treedata = result.data;
        });
    }


    /*
     * managed tree option select event 
     * @Param {Object} $node object of selected tree option
     */
    selectGenre ( $node ) {

        this.genreModel = $node;
        this.$mdDialog.hide( $node );
    }


    /*
     * managed CANCEL event from dailog
     */ 
    cancelButton () {

        this.$mdDialog.cancel();
    }
}


/*
 * Inject dependicies
 */
TreeControllerDialogCtrl.$inject = ['$scope', '$mdDialog', '$http', 'genreModel'];


/*
 * Browsify connection: execute controller
 */
module.exports = TreeControllerDialogCtrl;
